import { useIntl } from 'react-intl';

export const useTranslations = () => {
  const translations = useIntl();
  const translate = (key: string) => translations.formatMessage({ id: key }) || key;
  return translate;
};
